import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Customers' })((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 64
    },
    carousel: {
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            paddingLeft: 248
        }
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gridTemplateRows: 'repeat(2, 1fr)',
        gap: 20
    },
    item: {
        color: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 141,
        width: '100%',
        maxWidth: 240,
        flex: '1 0 0',
        boxSizing: 'border-box',
        borderRadius: 24,
        background: 'rgba(255, 255, 255, 0.03)',
        backdropFilter: 'blur(50px)',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            width: 240
        }
    }
}));
